import { render } from "./AWS_FileUploader.vue?vue&type=template&id=b9932c86"
import script from "./AWS_FileUploader.vue?vue&type=script&lang=js"
export * from "./AWS_FileUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__